import * as React from 'react';

import { CoworkingAmenitiesList } from '../../../../components/Commercial/CoworkingAmenitiesList';
import { useOfferContext } from '../../../../context';

export function CoworkingAmenitiesContainer() {
  const { offer } = useOfferContext();
  const { coworking } = offer;

  if (!coworking?.includedAmenities?.length) {
    return null;
  }

  return (
    <CoworkingAmenitiesList
      amenities={coworking.includedAmenities}
      moreAmenitiesCount={coworking.moreAmenitiesCount}
      url={coworking.url}
    />
  );
}

CoworkingAmenitiesContainer.displayName = 'CoworkingAmenitiesContainer';
